<template>
  <div>
    <div class="index_nav_div" style="padding-top: 10px;">
      <div class="bg_div">
        <table>
          <tbody>
            <tr>
              <th>&nbsp;</th>
              <td class="td_y">
                <font>当前所在位置：</font><a href="/" target="_self">首页</a>&nbsp;》&nbsp;<a style="text-decoration: none">{{
                  menuName }}</a>
              </td>
              <td class="td_bg">&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div id="content">
      <div class="news clearfix">
        <div class="title_div">
          <span class="title_left">{{ menuName }}</span>
        </div>
        <div class="cont">
          <div style="padding-top: 10px">
            <el-table :data="tableData" style="width: 100%">
              <el-table-column prop="title">
                <template #default="scope">
                  <el-link @click="goArticle(scope.row.threadId)">
                    {{ scope.row.title }}
                  </el-link>
                </template>
              </el-table-column>
              <el-table-column prop="createTime" width="100" />
            </el-table>
          </div>
          <pagination :total="total" v-model:page="queryParams.page" v-model:limit="queryParams.size"
            @pagination="getList" />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getListContent } from "@/api/home";
const route = useRoute();
const router = useRouter();
let queryP = ref({});
let queryParams = ref({
  page: 1,
  size: 10,
});
let menuName = ref("");
watch(
  () => route.query,
  (query, oldValue) => {
    queryP.value = query;
    menuName.value = query.d == 27 ? "会员简介" : "下载中心";
    getList();
  },
  {
    immediate: true,
  }
);

let tableData = ref([]);
let total = ref(0);
function getList() {
  getListContent({
    ...queryP.value,
    ...queryParams.value,
  }).then((res) => {
    if (res.code === 200 && res.data) {
      tableData.value = res.data.records;
      total.value = res.data.totalCount || res.data.total || 0;
      //   res.data.menuVO.forEach((item) => {
      //     breadCrumb.value.push({
      //       name: item.menuName,
      //       path: item.menuUrl,
      //     });
      //     if (item.menuVOS !== null) {
      //       item.menuVOS.forEach((inItem) => {
      //         breadCrumb.value.push({
      //           name: inItem.menuName,
      //           path: inItem.menuUrl,
      //         });
      //       });
      //     }
      //   });
    }
  });
}
function goArticle(id) {
  openInNewTab(`/article-detail/${id}`);
}
function openInNewTab(path, query) {
  const url = router.resolve({ path, query }).href;
  window.open(url, "_blank");
}
</script>

<style lang="scss" scoped>
.cont {
  width: 100%;
  height: auto;
  margin-bottom: 30px;
}

.title_div {
  width: 100%;
  height: 35px;
  background: url(@/assets/images/lxbg.png) no-repeat center left;
}

.title_div .title_left {
  font: 18px/36px "SimSun", sans-serif;
  font-weight: bold;
  color: #fff;
  margin-left: 10px;
  padding: 0;
  vertical-align: top;
  text-shadow: 0 0 0.2em #f87, -0 -0 0.2em #f87;
}

.title_div .title_left i {
  font: 12px/40px "SimSun", sans-serif;
  font-weight: normal;
  color: #fff;
  margin-left: 10px;
  vertical-align: text-bottom;
  text-shadow: 0 0 0.2em #f87, -0 -0 0.2em #f87;
}

.title_div .title_right {
  background: url(@/assets/images/t_tb.png) no-repeat 750px center;
  float: right;
  display: block;
  width: 780px;
  font: 12px/40px "SimSun", sans-serif;
  font-weight: normal;
  color: #fff;
  margin-left: 10px;
  vertical-align: text-bottom;
  text-shadow: 0 0 0.2em #f87, -0 -0 0.2em #f87;
}
</style>
